// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Km4y","footer":"styles_footer__1d4oT"};